<template>
    <div style="position: relative">
        <div class="col-xs-3" style="height: 100%; padding:0" v-if="largeScreen" v-show="!this.loading">
            <dashboard-item-menu
                ref="hourZeroPreventionTimelineDashboardItemMenu"
                :titleColor="mainTitleColor"
                :titleBackgroundColor="mainTitleBackgroundColor"
                :title="mainTitle"
                :menuList="hourZeroPreventionTimelineMenuList"
                @menuItemClicked="onHourZeroPreventionTimelineItemSelect">
            </dashboard-item-menu>
        </div>
        <div class="col-xs-3" style="height: 100%; padding:0" v-if="!largeScreen">
            <dashboard-item-menu
                ref="hourZeroPreventionTimelineDashboardItemMenu"
                :titleColor="mainTitleColor"
                :titleBackgroundColor="mainTitleBackgroundColor"
                :title="mainTitle"
                :menuList="hourZeroPreventionTimelineMenuList"
                @menuItemClicked="onHourZeroPreventionTimelineItemSelect">
            </dashboard-item-menu>
        </div>
        <div class="col-xs-9" style="height: 100%; position: relative;" v-if="largeScreen">
            <div class="hour-zero-chart">
                <div class='legendTable' v-if="!loading">
                    <div class='legend-component'>
                        <div class="purple">&nbsp;</div>
                        <p class="title">Number of unverdicted files</p>
                    </div>
                    <div class='legend-component'>
                        <div class="green">&nbsp;</div>
                        <p class="title">Average time of unverdicted files</p>
                    </div>
                </div>
                <hour-zero-time-line v-if="this.fetch_data" v-show="!this.loading" :height="350"
                                     :chart-labels="chart_labels"
                                     :chart-data-hour="this.chart_data_hour"
                                     :chart-data-file-count="this.chart_data_file_count"
                                     @pointsClicked="pointsClicked"
                ></hour-zero-time-line>
            </div>
        </div>
        <div class="col-xs-9" style="height: 100%; position: relative;" v-if="!largeScreen">
            <div class="hour-zero-chart">
                <div class='legendTable' v-if="!loading">
                    <div class='legend-component'>
                        <div class="purple">&nbsp;</div>
                        <p class="title">Number of unverdicted files</p>
                    </div>
                    <div class='legend-component'>
                        <div class="green">&nbsp;</div>
                        <p class="title">Average time of unverdicted files</p>
                    </div>
                </div>
                <hour-zero-time-line-maximize v-if="this.fetch_data" v-show="!this.loading" :height="350"
                                              :chart-labels="chart_labels"
                                              :chart-data-hour="this.chart_data_hour"
                                              :chart-data-file-count="this.chart_data_file_count"
                                              @pointsClickedFromMaximize="pointsClickedFromMaximize"
                ></hour-zero-time-line-maximize>
                <h3 v-show="!this.loading" class="unverdicted-file-count">{{this.unverdictedFileCount}} Files not
                    verdicted by {{this.selectedVendorName}} on {{this.selectedDay}}</h3>
                <hour-zero-time-line-table v-if="this.fetch_data && this.selectedDayFiles"
                                           v-show="this.fetch_data && this.selectedDayFiles"
                                           :selected-day-files="this.selectedDayFiles"></hour-zero-time-line-table>
            </div>
        </div>
        <div class="enlarge-button grow" @click="onEnlargeClick">
            <img src="../../../assets/enlarge-button.svg" class="enlarge-button-icon"/>
        </div>
        <loading-modal v-if="loading" :color="'blue'"></loading-modal>
    </div>
</template>

<script>
    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import LoadingModal from "@/components/modals/LoadingModal";
    import moment from 'moment-timezone';

    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "#00EFF9";
    const MENU_ITEM_BACKGROUND_COLOR = "#00B1BA";
    const MENU_ITEM_COLOR = "rgb(63,92,111)";
    const MENU_TITLE_COLOR = "white";
    const SMALL_SCREEN_INTERVAL = 10;
    const LARGE_SCREEN_INTERVAL = 30;
    const HOUR_SECONDS = 60 * 60;
    const MINUTE_SECONDS = 60;

    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';
    import HourZeroTimeLine from "../../../components/hour-zero-prevention-timeline/HourZeroTimeLine"
    import HourZeroTimeLineMaximize from "../../../components/hour-zero-prevention-timeline/HourZeroTimeLineMaximize"
    import HourZeroTimeLineTable from "../../../components/hour-zero-prevention-timeline/HourZeroTimeLineTable"

    export default {
        name: "hour-zero-prevention-timeline",
        components: {
            DashboardItemMenu: DashboardItemMenu,
            LoadingModal: LoadingModal,
            HourZeroTimeLine: HourZeroTimeLine,
            HourZeroTimeLineMaximize: HourZeroTimeLineMaximize,
            HourZeroTimeLineTable: HourZeroTimeLineTable
        },
        props: {
            itemNumber: {
                type: Number,
                required: true
            }
        },
        mixins: [Common],
        data() {
            return {
                mainTitle: 'HOUR\nZERO\nPREVENTION\nTIMELINE',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,
                loading: false,
                hourZeroPreventionTimelineMenuList: [],
                selectedHourZeroPreventionTimelineItem: {},
                largeScreen: true,
                enLargeClicked: null,
                vendorList: [],
                partCount: null,
                maxTime: null,
                chart_labels: null,
                chart_data_file_count: null,
                chart_data_hour: null,
                fetch_data: false,
                selectedDay: null,
                selectedDayFiles: {},
                allFilesForVendor: {},
                unverdictedFileCount: null,
                selectedVendorName: null
            }
        },
        methods: {
            pointsClicked(evt, clickedIndex) {
                this.loading = true;
                this.selectedDay = this.chart_labels[clickedIndex];
                this.onEnlargeClick();
                this.loading = false;
            },
            pointsClickedFromMaximize(evt, clickedIndex) {
                this.loading = true;
                this.selectedDay = this.chart_labels[clickedIndex];
                this.setSelectedDay();
                this.loading = false;
            },
            onHourZeroPreventionTimelineItemSelect(menuItem) {
                this.loading = true;
                this.selectedHourZeroPreventionTimelineItem = null;
                this.$nextTick(function () {
                    this.selectedHourZeroPreventionTimelineItem = menuItem;
                });
                this.setSelectedHourZeroPreventionTimelineItem(menuItem);
                this.setGraphDatas(menuItem);
                this.loading = false;
            },
            onEnlargeClick() {
                this.enLargeClicked = this.getDashboardEnlargedItem;
                if (this.enLargeClicked != null) {
                    this.largeScreen = true;
                    this.fetch_data = false;
                    this.getVendorList();
                }
                else {
                    this.largeScreen = false;
                    this.fetch_data = false;
                    this.getVendorList();
                }
                this.setGraphLabels();
                this.setDashboardEnlargedItem(this.itemNumber);
            },
            setGraphDatas(menuItem) {
                this.fetch_data = false;
                let vendorName = '';
                let missingDays = 0;
                if (menuItem === undefined) {
                    if (this.selectedHourZeroPreventionTimelineItem != null)
                        vendorName = this.selectedHourZeroPreventionTimelineItem.text;
                } else {
                    vendorName = menuItem.text;
                }
                this.selectedVendorName = vendorName;
                if (this.largeScreen) {
                    var body = {
                        interval: SMALL_SCREEN_INTERVAL,
                        vendor: vendorName
                    };
                    missingDays = SMALL_SCREEN_INTERVAL;
                    this.chart_data_hour = new Array(SMALL_SCREEN_INTERVAL).fill(0);
                    this.chart_data_file_count = new Array(SMALL_SCREEN_INTERVAL).fill(0);
                }
                else {
                    var body = {
                        interval: LARGE_SCREEN_INTERVAL,
                        vendor: vendorName
                    };
                    missingDays = LARGE_SCREEN_INTERVAL;
                    this.chart_data_hour = new Array(LARGE_SCREEN_INTERVAL).fill(0);
                    this.chart_data_file_count = new Array(LARGE_SCREEN_INTERVAL).fill(0);
                }
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/antivirusvendor/get/vendor_hour_zero_timeline';
                this.$http.post(path, body).then(response => {
                    this.allFilesForVendor = response.body.data;
                    if(response.body.data == null) {
                        this.loading = false;
                        return;
                    }

                    for (let i = 0; i < response.body.data.length; i++) {
                        let dataDate = moment(response.body.data[i].timeline_date).format('MMM D');
                        let index = this.chart_labels.indexOf(dataDate);
                        this.chart_data_file_count[index] = response.body.data[i].file_count;
                        this.chart_data_hour[index] = response.body.data[i].timeline_value;
                    }
                    this.setSelectedDay();
                    this.loading = false;
                    this.fetch_data = true;
                }, response => {
                });

            },
            setSelectedDay() {
                let isDayExist = false;
                for (let i = 0; i < this.allFilesForVendor.length; i++) {
                    let dataDate = moment(this.allFilesForVendor[i].timeline_date).format('MMM D');
                    if (this.selectedDay == dataDate || this.selectedDay === null) {
                        isDayExist = true;
                        this.selectedDay = dataDate;
                        this.selectedDayFiles = this.allFilesForVendor[i].files;
                        this.unverdictedFileCount = this.allFilesForVendor[i].file_count;
                        break;
                    }
                }
                if (!isDayExist) {
                    this.unverdictedFileCount = 0;
                    this.selectedDayFiles = null;
                }
            },
            setGraphLabels() {
                let interval;
                if (this.largeScreen) {
                    interval = SMALL_SCREEN_INTERVAL;
                } else {
                    interval = LARGE_SCREEN_INTERVAL;
                }
                let arr = [];
                let startDate = moment().add((-1 * interval), 'days');
                for (let i = 0; i < interval; i++) {
                    arr.push(startDate.clone().add(i, 'days').format('MMM D'));
                }
                this.chart_labels = arr;
            },
            getVendorList() {
                let log_start = Date.now();
                this.loading = true;
                if (this.largeScreen) {
                    var body = {
                        interval: SMALL_SCREEN_INTERVAL
                    }
                }
                else {
                    var body = {
                        interval: LARGE_SCREEN_INTERVAL
                    }
                }
                var path = Constants.INTELLIGENCE_BACKEND_URL + '/antivirusvendor/get/hour_zero_timeline';
                this.$http.post(path, body).then(response => {

                    this.vendorList = response.body.data;
                    this.setMaxTime();
                    this.selectedHourZeroPreventionTimelineItem = this.getSelectedHourZeroPreventionTimelineItem;
                    var items = [];
                    for (var i = 0; i < this.vendorList.length; i++) {
                        var item = {
                            id: this.uuidv4(),
                            enumNo: i,
                            text: this.vendorList[i].vendor,
                            color: MENU_ITEM_COLOR,
                            progress: this.getItemProgress(this.vendorList[i].time),
                            progressColor: "red",
                            selectedColor: "white",
                            selected: false
                        };
                        if (this.selectedHourZeroPreventionTimelineItem != null) {
                            item.selected = this.selectedHourZeroPreventionTimelineItem.text === item.text;

                            if (item.selected) {
                                this.$nextTick(function () {
                                    this.selectedHourZeroPreventionTimelineItem = item;
                                });
                            }
                        } else {
                            item["selected"] = true;
                            this.selectedHourZeroPreventionTimelineItem = item;
                            this.setSelectedHourZeroPreventionTimelineItem(item);
                        }
                        items.push(item)
                    }
                    if (this.largeScreen) {
                        let isSmallScreenContains = false;
                        for (var i = 0; i < items.length; i++) {
                            if (this.selectedHourZeroPreventionTimelineItem.text === items[i].text) {
                                items[i]["selected"] = true;
                                isSmallScreenContains = true;
                                break;
                            }
                        }
                        if (!isSmallScreenContains) {
                            if (items.length > 0) {
                                items[0]["selected"] = true;
                                this.selectedHourZeroPreventionTimelineItem = items[0];
                                this.setSelectedHourZeroPreventionTimelineItem(items[0]);
                            }
                        }
                    }
                    this.hourZeroPreventionTimelineMenuList = [
                        {
                            type: "selectableProgress",
                            text: "VENDOR",
                            color: MENU_TITLE_COLOR,
                            backgroundColor: MENU_ITEM_BACKGROUND_COLOR,
                            open: true,
                            items: items
                        }
                    ];
                    this.loading = false;
                    this.$emit('loaded', 'hour-zero-prevention-timeline', this.getDurationInSeconds(log_start, Date.now()));
                    this.setGraphDatas();
                }, response => {
                });
            },
            getItemProgress(item) {
                // return (100 * item.time) / this.maxTime;
                if (item >= this.maxTime) {
                    return 100;
                }

                var avg_hour = item / HOUR_SECONDS;
                let _interval = Math.log2(avg_hour);
                let low_val = Math.floor(_interval);
                let high_val = low_val + 1;
                let percent = (100 / this.partCount) * low_val;
                let current_interval = Math.pow(2, high_val) - Math.pow(2, low_val);
                let low_distance = avg_hour - Math.pow(2, low_val);
                let _add_value = (low_distance / current_interval) * (100 / this.partCount);

                var returnPercent = percent + _add_value;
                if (returnPercent > 100) {
                    return 100;
                } else {
                    if (percent === 0) {
                        percent = percent + 1;
                    }
                    return percent + _add_value;
                }
            },
            setMaxTime() {
                var maxTime = 0;
                for (let i = 0; i < this.vendorList.length; i++) {
                    let data = this.vendorList[i].time;
                    if (data > maxTime)
                        maxTime = data;
                }
                this.maxTime = maxTime;
                this.partCount = Math.log2(this.maxTime / HOUR_SECONDS);
            },
            checkLargePage() {
                this.enLargeClicked = this.getDashboardEnlargedItem;
                if (this.enLargeClicked == this.itemNumber) {
                    this.largeScreen = false;
                }
            },
            ...mapActions([
                "setDashboardEnlargedItem",
                "setSelectedHourZeroPreventionTimelineItem"
            ])
        },
        computed: {
            ...mapGetters([
                "getSelectedHourZeroPreventionTimelineItem",
                "getDashboardEnlargedItem"
            ])
        },
        mounted() {
            // this.getVendorList();
        },
        beforeMount() {
            this.getVendorList();
            this.checkLargePage();
            this.setGraphLabels();
        }
    }
</script>

<style scoped>

    .purple {
        background: rgba(154, 63, 200, 1.5);
        position: relative;
        z-index: 1;
        width: 40px;
        height: 10px;
    }

    .green {
        background: rgb(6, 224, 112);
        position: relative;
        z-index: 1;
        width: 40px;
        height: 10px;
    }

    .title {
        display: inline;
        margin-left: 20px;
        font-size: 12px;
        color: #919191;
        margin-bottom: 0 !important;
        margin-top: 5px;
    }

    .legend-component {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .legendTable {
        margin-top: 10px;
    }

    #line-chart {
        height: 300px !important;
    }

    .unverdicted-file-count {
        color: white;
        font-family: Digital-Serial-Bold;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/hour-zero-prevention-timeline/HourZeroPreventionTimeline.vue